export default __webpack_public_path__ + "static/media/Indie.df32d12e.svg";